import { fallbackLng } from 'i18n/i18n.config';

export const getI18nLanguageRequest = () => {
  const langFromSearchParams =
    new URLSearchParams(window.location.search).get('lang') || '';

  // Simple validation to filter out blatantly invalid inputs.
  const language =
    langFromSearchParams && /^[a-z_-]{2,10}$/i.test(langFromSearchParams)
      ? langFromSearchParams
      : fallbackLng;

  return {
    language,
  };
};
